const KAKAO_PIXEL_ID =process.env.REACT_APP_KAKAO_ID || '';
export default KAKAO_PIXEL_ID;
